var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLessonIcon06(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.43286 16.7503C3.43286 16.1978 3.65235 15.6679 4.04306 15.2772C4.43376 14.8865 4.96366 14.667 5.51619 14.667H16.7662",
    stroke: "#2C323F",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.51619 2.16699H16.7662V18.8337H5.51619C4.96366 18.8337 4.43376 18.6142 4.04306 18.2235C3.65235 17.8328 3.43286 17.3029 3.43286 16.7503V4.25033C3.43286 3.69779 3.65235 3.16789 4.04306 2.77719C4.43376 2.38649 4.96366 2.16699 5.51619 2.16699V2.16699Z",
    stroke: "#2C323F",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessonIcon06);
export default __webpack_public_path__ + "static/media/lesson-icon-06.3cc9bb7e32dc1acdeb933039893fca89.svg";
export { ForwardRef as ReactComponent };